import { render, staticRenderFns } from "./assignee-dialog.html?vue&type=template&id=c5ec9048&scoped=true&external"
import script from "./assignee-dialog.js?vue&type=script&lang=js&external"
export * from "./assignee-dialog.js?vue&type=script&lang=js&external"
import style0 from "./assignee-dialog.scss?vue&type=style&index=0&id=c5ec9048&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ec9048",
  null
  
)

export default component.exports